 if ($('.subcategories').length) {
    $('.subcategories li img').each(function () {
        if ($(this).attr('data-src').includes('/folder.svg')) {
            $('.subcategories').addClass('thirdLevel');
        }
    });        
}

if($('.category__secondDescription p').text().length>1){
    $('.category-perex').append('<div class="text-right"><span class="bottomDsc"><strong>Číst dál</strong></span></div>');
    $('.category__secondDescription').append('<div class="text-right"><span class="topDsc"><strong>Na začátek textu</strong></span></div>');
}

$('html').on('click', '.bottomDsc', function(e){
    e.preventDefault();
    $("html, body").animate({
      scrollTop: $(".category__secondDescription").offset().top
    }, 400);
})

$('html').on('click', '.topDsc', function(e){
    e.preventDefault();
    $("html, body").animate({
      scrollTop: $(".category-perex").offset().top
    }, 400);
})